import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
/** Zona drag-and-drop + click-to-pick + miniatura. Sólo acepta imágenes. */
export default function ImageDrop({ label, file, onFile, hint }) {
    const inputRef = useRef(null);
    const [over, setOver] = useState(false);
    const [preview, setPreview] = useState(null);
    const setBoth = (f) => {
        onFile(f);
        if (preview)
            URL.revokeObjectURL(preview);
        setPreview(f ? URL.createObjectURL(f) : null);
    };
    const onDrop = (e) => {
        e.preventDefault();
        setOver(false);
        const f = e.dataTransfer.files?.[0];
        if (f && f.type.startsWith('image/'))
            setBoth(f);
    };
    return (_jsxs("div", { className: `image-drop ${over ? 'over' : ''} ${file ? 'has-file' : ''}`, onClick: () => inputRef.current?.click(), onDragEnter: (e) => { e.preventDefault(); setOver(true); }, onDragOver: (e) => { e.preventDefault(); setOver(true); }, onDragLeave: () => setOver(false), onDrop: onDrop, role: "button", tabIndex: 0, children: [_jsx("input", { ref: inputRef, type: "file", accept: "image/*", hidden: true, onChange: (e) => setBoth(e.target.files?.[0] ?? null) }), preview ? (_jsx("img", { src: preview, alt: label, className: "image-drop-preview" })) : (_jsxs("div", { className: "image-drop-placeholder", children: [_jsx("strong", { children: label }), hint && _jsx("span", { className: "muted", children: hint })] }))] }));
}
